<template>
  <div>
    <p class="tw:font-bold tw:mb-3">{{ label }}</p>
    <div class="tw:relative tw:mb-2" v-if="options.length > 10">
      <Search class="tw:absolute tw:top-[15px] tw:right-[25px] tw:size-[17px]" />
      <input
        class="tw:border box-size-44 tw:border-gray-300 tw:rounded-md tw:px-2 tw:py-1 tw:outline-hidden tw:w-full"
        type="text"
        :value="searchQuery"
        @input="e => search(e.target.value)"
        :placeholder="$t('search_placeholder')"
      />
    </div>
    <ul class="tw:flex tw:flex-wrap">
      <li
        v-for="option in optionsToShow"
        :key="option.id"
        :class="type === 'flyout' ? 'flyout-item' : 'item'"
        class="tw:flex tw:items-center tw:text-sm"
      >
        <input
          type="checkbox"
          :name="name"
          :value="option.id"
          :id="`${name}_${option.id}`"
          :checked="isSelected(option)"
          @change="onSelect(option)"
          class="tw:cursor-pointer"
        />
        <label
          :for="`${name}_${option.id}`"
          class="tw:cursor-pointer tw:py-2 tw:m-0 tw:pl-3 tw:grow tw:flex tw:items-center tw:flex-wrap"
          >{{ $t(option.label) }}</label
        >
      </li>
    </ul>
    <button
      v-if="filteredOptions?.length > 6"
      @click="toggleShowMore"
      class="tw:py-2 tw:text-sm tw:text-blue-700 tw:font-bold tw:hover:text-blue-900 tw:hover:cursor-pointer"
    >
      {{ filteredOptions.length === optionsToShow.length ? $t('show_less') : $t('show_more') }}
    </button>
  </div>
</template>
<script setup>
import Search from '@/components/icons/Search.svg?component'
import { computed, ref, watch } from 'vue'

const emit = defineEmits(['onSelect'])
const onSelect = value => emit('onSelect', value)

const props = defineProps({
  name: String,
  label: String,
  options: Array,
  value: Object,
  type: String,
})

const searchQuery = ref('')
const showAll = ref(false)
const filteredOptions = ref(props.options)
const optionsToShow = computed(() => {
  if (filteredOptions.value?.length > 6 && !showAll.value) {
    return filteredOptions.value?.slice(0, 6)
  } else {
    return filteredOptions.value
  }
})

const isSelected = item => {
  return props.value.filter(option => option.id === item.id)?.length > 0
}
const toggleShowMore = () => {
  showAll.value = !showAll.value
}

const search = text => {
  searchQuery.value = text
}

watch(searchQuery, newSearchQuery => {
  const q = newSearchQuery.trim().toLowerCase()
  filteredOptions.value =
    q.length === 0
      ? props.options
      : props.options.filter(item => {
          const key = (item.label ?? '').toLowerCase()
          return key.includes(q)
        })
})
</script>
<style scoped>
.item {
  flex-basis: 100%;
  box-sizing: border-box;
}
.flyout-item {
  flex-basis: 50%;
}
</style>
